import { render } from "./Variety_detail_image.vue?vue&type=template&id=0f460746&scoped=true"
import script from "./Variety_detail_image.vue?vue&type=script&lang=js"
export * from "./Variety_detail_image.vue?vue&type=script&lang=js"

import "./Variety_detail_image.vue?vue&type=style&index=0&id=0f460746&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f460746"]])

export default __exports__